import { Currency, formatToDollar, formatToPercent } from "@inrev/common";
import { Option } from "@inrev/core";
import { formatEmpty } from "../../../utils";

const RATE_FRACTION_DECIMALS = 7;

export const formatRateCell = (rate: Option<number>): string =>
	formatEmpty(Option.isNone(rate) ? null : formatToPercent(rate, 3));

export const rateToInputValue = (rate: Option<number>): string =>
	Option.isNone(rate) ? "" : formatToPercent(rate, 5).replace("%", "");

export const parseRateInput = (draft: string): number | null | undefined => {
	const trimmed = draft.trim();
	if (trimmed === "") return null;
	const percent = Number.parseFloat(trimmed);
	if (!Number.isFinite(percent)) return undefined;
	const factor = 10 ** RATE_FRACTION_DECIMALS;
	return Math.trunc((percent / 100) * factor) / factor;
};

export const formatLimitCell = (value: Option<number>): string => {
	if (Option.isNone(value)) return formatEmpty(null);
	const formatted = formatToDollar(value);
	return typeof formatted === "string" ? formatted : formatEmpty(null);
};

export const limitToInputValue = (value: Option<number>): string =>
	Option.isNone(value) ? "" : String(value);

export const parseLimitInput = (draft: string): number | null | undefined => {
	const trimmed = draft.trim();
	if (trimmed === "") return null;
	if (!Number.isFinite(Number(trimmed))) return undefined;
	return Currency.parse(trimmed);
};
